import { render, staticRenderFns } from "./DevisForm.vue?vue&type=template&id=64a96860&"
import script from "./DevisForm.vue?vue&type=script&lang=js&"
export * from "./DevisForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64a96860')) {
      api.createRecord('64a96860', component.options)
    } else {
      api.reload('64a96860', component.options)
    }
    module.hot.accept("./DevisForm.vue?vue&type=template&id=64a96860&", function () {
      api.rerender('64a96860', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/attachments/DevisForm.vue"
export default component.exports